import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import postWithState from 'client/actions/postWithState';

import { USER_ROLE_ADMIN } from 'common/userRoles';
import { SR_API_ACTION_SET_REDIRECTION, SR_API_ACTION_DELETE_REDIRECTION } from 'api/actionTypes';
import { SCREEN_ID_ADMIN_REDIRECTIONS } from 'client/constants/screenIds';

import {
  DATA_TABLE_SOURCE_REDIRECTIONS,
  DATA_TABLE_VIEW_ID_REDIRECTIONS,
} from 'common/dataTableConstants';

import branch from 'client/core/branch';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withTransitionHook from 'client/helpers/withTransitionHook';
import allowedRoles from 'client/helpers/allowedRoles';
import { createFormValidationFn, createInitialValues } from 'client/helpers/formikHelpers';
import { actionDataTableLoadItems, actionDataTableRemoveItem } from 'client/helpers/dataTables';

import H1 from 'client/components/H1';
import SrBox from 'client/components/SrBox';
import Navbar from 'client/components/Navbar';
import SrFormikField from 'client/components/SrFormikField';
import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrDataTableConnected from 'client/components/SrDataTableConnected';

const formFields = [
  {
    id: 'id',
    type: 'short_text',
    properties: {
      placeholder: 'A1',
    },
    validations: ['required'],
  },
  {
    id: 'url',
    type: 'short_text',
    properties: {
      placeholder: 'https://sunroomrentals.com/listing/1',
    },
    validations: ['required'],
  },
];

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScrollToTop
@withScreenId(SCREEN_ID_ADMIN_REDIRECTIONS)
@branch()
class AdminRedirectionsPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Admin Redirects | Sunroom Rentals',
    section: 'Admin',
  });

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  };

  _onSubmitForm = (values, formikBag) => {
    const { dispatch } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_SET_REDIRECTION,
      payload: values,
      onSuccess: (redirection) => {
        formikBag.resetForm();

        dispatch(actionDataTableLoadItems, {
          dataSource: DATA_TABLE_SOURCE_REDIRECTIONS,
          viewId: `redirection-id-${redirection.id}`,
          filter: {
            'redirections.id': redirection.id,
          },
          sort: {
            createdDate: 'desc',
          },
          count: 1,
        });
      },
    });
  };

  _onDeleteRedirection = (id) => {
    const { dispatch } = this.props;
    if (!global.confirm('Are you sure you want to delete this redirection?')) {
      return;
    }
    dispatch(postWithState, {
      action: SR_API_ACTION_DELETE_REDIRECTION,
      payload: { id },
      onSuccess: () => {
        dispatch(actionDataTableRemoveItem, {
          dataSource: DATA_TABLE_SOURCE_REDIRECTIONS,
          entityId: id,
        });
      },
    });
  };

  render() {
    return (
      <div className="page-admin">
        <div className="adminContainer">
          <Navbar redirectLogoTo="/admin" />

          <div className="contentContainer">
            <H1>Redirections</H1>

            <SrBox margin="0 0 20px">
              <Formik
                enableReinitialize
                initialValues={createInitialValues({
                  formFields: formFields,
                  defaultValues: {},
                })}
                onSubmit={this._onSubmitForm}
                validate={createFormValidationFn(formFields)}
                render={(formikBag) => {
                  return (
                    <div>
                      {formFields.map((formField) => (
                        <SrFormikField
                          key={formField.id}
                          formField={formField}
                          formikBag={formikBag}
                        />
                      ))}

                      <ButtonDeprecated
                        className="save"
                        onClick={formikBag.handleSubmit}
                        disabled={!formikBag.isValid}
                      >
                        run
                      </ButtonDeprecated>
                    </div>
                  );
                }}
              />
            </SrBox>

            <SrDataTableConnected
              itemsPropName="redirections"
              rootViewId={DATA_TABLE_VIEW_ID_REDIRECTIONS}
              dataSource={DATA_TABLE_SOURCE_REDIRECTIONS}
              initialViewSettings={{
                sort: {
                  id: 'asc',
                },
              }}
              count={100}
            >
              {({ redirections, onInfiniteScrollWrapperRef }) => {
                return (
                  <table ref={onInfiniteScrollWrapperRef}>
                    <thead>
                      <tr>
                        <th>Shortcut</th>
                        <th>Redirect</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {redirections.map((redirect) => (
                        <tr key={redirect.id}>
                          <td>{redirect.id}</td>
                          <td>{redirect.url}</td>
                          <td>
                            <span onClick={() => this._onDeleteRedirection(redirect.id)}>🗑</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                );
              }}
            </SrDataTableConnected>
          </div>
        </div>
      </div>
    );
  }
}

AdminRedirectionsPage.displayName = 'AdminRedirectionsPage';

export default AdminRedirectionsPage;
